import React, { useEffect, useReducer } from 'react';
import styles from './WinMessages.scss';

import WinMessagesCustom from './WinMessages.custom';
import WinMessagesLevels from './WinMessages.list';
import WinMessagesofAKindModifier from './WinMessages.ofAKindModifier';
import WinMessagesTimer from './WinMessages.timer';

// MANAGERS
import { useAppSelector } from '@Managers/Redux/Hooks';

import { getOfAKind } from '@Managers/Redux/AppState/AppState';

interface IComponentState {}

const WinMessages: React.FC = () => {
    const [state, setState] = useReducer((s: IComponentState, ns: Partial<IComponentState>) => ({ ...s, ...ns }), {});
    const gameStoreOfAKind = useAppSelector(getOfAKind);

    useEffect(() => {}, []);

    return (
        <div className={styles.winMessages_container}>
            <div className={styles.winMessages_winning_group}>
                <div>
                    {gameStoreOfAKind && <WinMessagesofAKindModifier />}
                    <WinMessagesLevels />
                </div>

                <WinMessagesCustom />
            </div>

            <WinMessagesTimer />
        </div>
    );
};

export default WinMessages;
